<template>
<v-container fluid grid-list-md>
  <v-card class="mb-2">
    <v-card-title>
      <span class="headline mb-0">稼働年月詳細</span>
    </v-card-title>
    <v-form v-model="valid">
      <v-layout row style="margin-top: 24px !important" wrap>
        <v-flex md12 sm12 style="padding: 0px !important; padding-right: 10px">
          <v-tabs v-model="tab">
            <v-tab>基本カレンダー</v-tab>
            <v-tab-item>
              <v-card>
                <calendar type="BASIC_CALENDAR" style="width: 100%" v-model="query.basicCalendar" />
              </v-card>
            </v-tab-item>
            <v-tab>稼働日カレンダー</v-tab>
            <v-tab-item>
              <v-card>
                <calendar type="WORKING_CALENDAR" style="width: 100%" v-model="query.workingCalendar" />
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-form>
  </v-card>
</v-container>
</template>

<script>
import Calendar from './Calendar'

/* eslint-disable no-console */
export default {
  components: {
    Calendar
  },

  data() {
    return {
      tab: null,
      query: {},
      workingCalendar: [],
      valid: false,
    }
  },
  methods: {},
  watch: {},
}
</script>
